<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-eight">
<h1>Chapter Eight</h1>
<p>Both tossed and turned that night for different reasons, though one underlying reason reached its tentacles to both.</p>
<p>Joshua grabbed a pillow and pressed it hard over the back of his head, trying desperately to obliterate the noise permeating the thin wall. Henry Baker was drunk as a skunk and demanding his conjugal rights. Joshua heard his mother’s muffled protestations, his painful heart breaking in two. What had his mother done to deserve this despicable monster? She was a good mother. Caring, honest, loyal, and law-abiding, but what could she do in this lunatic’s clutches? He pressed the pillow harder, harder, and harder but could not annihilate the words seeping through. <em>You have potential, Joshua. Buck up. Revise. Succeed.</em> Neither could he eradicate the serious look in Missus Hamilton’s eyes. She was concerned. She had high hopes for him. She did not want him to fail, which was more than he could say for his stepdad, he morosely concluded. Throwing the pillow on to the floor, he sat at his study desk, opened his books, and stated aloud, “I shall succeed!”</p>
<p>Two streets away Abigail’s mind was filled with an irritating doubt niggling in her mind. Did she hear him correctly, or was it just her wishful imagination? Had Joshua Darlington inquired if she was going to the school disco and, if he had, why?</p>
<p>She switched on her bedside lamp, her eyes straying to the night table, on which lay a sealed envelope addressed to her parents from Missus Hamilton. In the subdued lighting of her room, she opened the drawer and placed the envelope inside, shutting the drawer firmly and decisively, her head teacher’s words ringing loudly in her ears. <em>You have the potential to reach the stars, Abigail.</em> She snapped off her bedside lamp and turned over.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch012.vue?5faba0ce